import { useEffect, useState } from 'react';
import { TextField, TextFieldProps, alpha, useTheme } from '@mui/material';
import { useField } from '@unform/core';
import { styled } from '@mui/material/styles';

type TVTextFieldProps = TextFieldProps & {
  name: string;
  valor?: (novoTextoselect: string | undefined) => void;
}

// Componente estilizado
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    backgroundColor: theme.palette.mode === 'dark' 
      ? alpha(theme.palette.background.default, 0.8)
      : alpha(theme.palette.common.white, 0.8),
    transition: 'all 0.3s ease',
    
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.light, 0.05),
      boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.2)}`,
    },
    
    '&.Mui-focused': {
      backgroundColor: alpha(theme.palette.primary.light, 0.08),
      boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.3)}`,
    },
  },
}));

export const VTextField: React.FC<TVTextFieldProps> = ({valor, name, ...rest }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField(name);
  const theme = useTheme();

  const [value, setValue] = useState(defaultValue || '');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => value,
      setValue: (_, newValue) => setValue(newValue),
    });
  }, [registerField, fieldName, value]);

  return (
    <StyledTextField
      {...rest}
      error={!!error}
      helperText={error}
      defaultValue={defaultValue}
      value={value}
      onChange={e => { setValue(e.target.value); valor?.(e.target.value); rest.onChange?.(e); }}
      onKeyDown={(e) => { error && clearError(); rest.onKeyDown?.(e); }}
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: '12px',
          backgroundColor: theme.palette.mode === 'dark' 
            ? alpha(theme.palette.background.default, 0.8)
            : alpha(theme.palette.common.white, 0.8),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.light, 0.05),
          },
          '&.Mui-focused': {
            backgroundColor: alpha(theme.palette.primary.light, 0.08),
          },
        },
      }}
    />
  );
};